import React from 'react';
import { Phone, Mail, Award } from 'lucide-react';
import { founderInfo } from '../mock';

const Founder = () => {
  return (
    <section id="founder" className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <div className="inline-block bg-amber-100 text-amber-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
              Leadership
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Meet Our <span className="bg-gradient-to-r from-blue-600 to-amber-500 bg-clip-text text-transparent">Founder</span>
            </h2>
          </div>

          {/* Founder Card */}
          <div className="bg-gradient-to-br from-blue-50 to-amber-50/30 rounded-3xl overflow-hidden shadow-2xl border border-gray-100">
            <div className="grid md:grid-cols-5 gap-0">
              {/* Image Side */}
              <div className="md:col-span-2 relative">
                <div className="aspect-square md:aspect-auto md:h-full relative overflow-hidden">
                  {/* Founder Photo */}
                  <img
                    src="https://customer-assets.emergentagent.com/job_hospital-loan-hub/artifacts/j7ag28as_Screenshot_20260602_083633_ChatGPT.jpg"
                    alt="D.N.V. Prasad - Founder & Owner"
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-blue-900/90 via-blue-900/50 to-transparent"></div>
                  
                  {/* Badge Overlay */}
                  <div className="absolute bottom-8 left-0 right-0 text-center z-10">
                    <div className="inline-flex items-center justify-center gap-2 bg-white/95 backdrop-blur-sm rounded-full px-6 py-3 shadow-xl">
                      <Award className="w-5 h-5 text-blue-600" />
                      <span className="font-semibold text-gray-900">Certified Financial Consultant</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Content Side */}
              <div className="md:col-span-3 p-8 md:p-12">
                <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">
                  {founderInfo.name}
                </h3>
                <p className="text-lg text-blue-600 font-semibold mb-6">{founderInfo.title}</p>

                <p className="text-lg text-gray-700 leading-relaxed mb-8">
                  {founderInfo.description}
                </p>

                {/* Contact Info */}
                <div className="space-y-4">
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 bg-gradient-to-br from-blue-600 to-blue-700 rounded-lg flex items-center justify-center flex-shrink-0">
                      <Phone className="w-6 h-6 text-white" />
                    </div>
                    <div>
                      <div className="text-sm text-gray-600">Direct Contact</div>
                      <a href={`tel:+91${founderInfo.phone}`} className="text-lg font-semibold text-gray-900 hover:text-blue-600 transition-colors">
                        +91 {founderInfo.phone}
                      </a>
                    </div>
                  </div>

                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 bg-gradient-to-br from-amber-500 to-amber-600 rounded-lg flex items-center justify-center flex-shrink-0">
                      <Mail className="w-6 h-6 text-white" />
                    </div>
                    <div>
                      <div className="text-sm text-gray-600">Email Address</div>
                      <a href="mailto:prasad@digiloansbazaar.com" className="text-lg font-semibold text-gray-900 hover:text-blue-600 transition-colors break-all">
                        prasad@digiloansbazaar.com
                      </a>
                    </div>
                  </div>
                </div>

                {/* Stats */}
                <div className="grid grid-cols-3 gap-4 mt-8 pt-8 border-t border-gray-200">
                  <div>
                    <div className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-amber-500 bg-clip-text text-transparent">8+</div>
                    <div className="text-sm text-gray-600">Years Exp.</div>
                  </div>
                  <div>
                    <div className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-amber-500 bg-clip-text text-transparent">500+</div>
                    <div className="text-sm text-gray-600">Clients</div>
                  </div>
                  <div>
                    <div className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-amber-500 bg-clip-text text-transparent">100%</div>
                    <div className="text-sm text-gray-600">Dedicated</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Founder;
